const CART_LINK_SELECTOR = '.ac-header__actions a[href*="/cart"], a.action__cart[href*="/cart"], a[aria-describedby="cart-bubble-text"][href*="/cart"]';
const DISCOUNT_TITLE_EN = 'Family Duo – Save $5 + Free Shipping';
const DISCOUNT_TITLE_FR = 'Duo familial – Économisez 5 $ + Livraison gratuite';

function openCartDrawer(event) {
  const link = event.target instanceof Element ? event.target.closest(CART_LINK_SELECTOR) : null;
  if (!(link instanceof HTMLAnchorElement)) return;

  const drawer = document.querySelector('#cart-drawer');
  if (!drawer || typeof drawer.open !== 'function') return;

  event.preventDefault();
  drawer.open();
}

function replaceText(root, selector, replacements) {
  const elements = root instanceof Element && root.matches(selector)
    ? [root]
    : Array.from(root.querySelectorAll?.(selector) || []);

  for (const element of elements) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();

    while (node) {
      let value = node.nodeValue || '';
      for (const [pattern, replacement] of replacements) value = value.replace(pattern, replacement);
      if (value !== node.nodeValue) node.nodeValue = value;
      node = walker.nextNode();
    }
  }
}

function localizeStorefront(root = document) {
  const language = document.documentElement.lang.toLowerCase();

  if (language.startsWith('fr')) {
    replaceText(root, 'main, #cart-drawer', [
      [/^\s*Cart\s*$/g, 'Panier'],
      [/^\s*You may also like\s*$/g, 'Vous aimerez peut-être aussi'],
      [new RegExp(DISCOUNT_TITLE_EN.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), DISCOUNT_TITLE_FR],
    ]);
    return;
  }

  if (language.startsWith('en')) {
    replaceText(root, 'main', [
      [/(\d+)\s+avis\b/gi, '$1 reviews'],
      [/Aucun avis/gi, 'No reviews'],
    ]);
  }
}

document.addEventListener('click', openCartDrawer, true);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => localizeStorefront(), { once: true });
} else {
  localizeStorefront();
}

// Review widgets render asynchronously, so run two small follow-up passes.
setTimeout(() => localizeStorefront(), 500);
setTimeout(() => localizeStorefront(), 1500);

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.type === 'characterData' && mutation.target.parentElement) {
      localizeStorefront(mutation.target.parentElement);
      continue;
    }

    for (const node of mutation.addedNodes) {
      if (node instanceof Element) localizeStorefront(node);
    }
  }
});

observer.observe(document.documentElement, { childList: true, characterData: true, subtree: true });
